<template>
    <section>
        <div :style="`z-index: 9999; position: fixed; right: 7%; top: ${screen_width >= 1265 ? '13px' : '80px;'}; width: auto`">
            <v-alert
                v-model="notif.show"
                dismissible
                transition="scroll-x-reverse-transition"
                :type="notif.type"
                :color="notif.color"
            >
                {{ notif.msg }}
            </v-alert>
        </div>
        <v-dialog v-model="showDialog">
            <v-card>
                <v-data-table
                    :items="coverages"
                    :headers="headers"
                    class="acuProvisionCoverage"
                    :items-per-page="-1"
                    :hide-default-footer="true"
                    fixed-header
                >
                    <template #top>
                        <v-card-title style="background-color: #009688; color: white;">
                            <v-chip style="font-weight: 700;">
                                {{ selectedAcu.ACCT_N }}
                            </v-chip>&nbsp; {{ selectedAcu.ACCT_M }}
                            <v-spacer />
                            <v-btn
                                v-if="showApproveAll"
                                color="warning"
                                @click="handleApproveAllPendingCoverages"
                            >
                                <v-icon>{{ mdiCheck }}</v-icon> Approve All
                            </v-btn>
                            &nbsp;
                            <v-btn
                                v-if="selectedAcu.STATUS === 'IN PROGRESS' || selectedAcu.STATUS === 'ACTIVE'"
                                color="success"
                                @click="handleNewCoverages"
                            >
                                <v-icon>{{ mdiPlus }}</v-icon> Add Coverage
                            </v-btn>
                            &nbsp;
                            <v-btn
                                color="error"
                                @click="showDialog = false"
                            >
                                <v-icon>{{ mdiClose }}</v-icon> Close
                            </v-btn>
                        </v-card-title>
                    </template>
                    <template #item="{ item, index }">
                        <tr
                            @mouseenter="hoveredRow = index"
                            @mouseleave="hoveredRow = null"
                        >
                            <td
                                v-for="header in headers"
                                :key="header.value"
                                :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', textAlign: header.value !== 'DIAG_T' ? 'center' : '' }"
                            >
                                <span style="text-wrap: nowrap">
                                    <template v-if="header.value === 'AGE'">
                                        {{ makeAgeStatement(item) }}
                                    </template>
                                    <template v-else-if="header.value === 'ADDED_BY'">
                                        {{ item.ADDED_BY }}
                                    </template>
                                    <template v-else-if="header.value === 'APPROVED_BY'">
                                        {{ item.APPROVED_BY ? item.APPROVED_BY : '-' }}
                                    </template>
                                    <template v-else-if="header.value === 'ADDED_ON'">
                                        {{ formatDate( item.ADDED_ON) }}
                                    </template>
                                    <template v-else-if="header.value === 'APPROVED_ON'">
                                        {{ item.APPROVED_ON ? formatDate(item.APPROVED_ON) : '-' }}
                                    </template>
                                    <template v-else-if="header.value === 'STATUS'">
                                        <div
                                            v-if="item.STATUS === 'ACTIVE'"
                                            style="width: 80px; color: #4caf50;"
                                        >
                                            <v-icon color="success">{{ mdiCheck }}</v-icon>Active
                                        </div>
                                        <div
                                            v-else
                                            :style="`width: 80px; color: ${item.STATUS === 'PENDING' ? '#fB9515' : '' }`"
                                        >
                                            <v-icon color="warning">{{ item.STATUS === 'PENDING' ? mdiTimerSand : '' }}</v-icon>Pending
                                        </div>
                                    </template>
                                    <template v-else-if="header.value === 'SEX'">
                                        <v-chip
                                            small
                                            :style="`background-color: ${item.SEX === 'F' ? 'pink' : item.SEX === 'M' ? '#1976D2' : 'gray'}; color: ${item.SEX === 'F' ? 'black' : 'white'}`"
                                        >{{ item.SEX === 'F' ? 'Female' : item.SEX === 'M' ? 'Male' : 'All' }}</v-chip>
                                    </template>
                                    <template v-else-if="header.value === 'ACTIONS'">
                                        <div :style="{ backgroundColor: hoveredRow === index ? '#EEE' : 'white', width: '180px', height: '50px', paddingTop: '5px', textAlign: 'center' }">
                                            <v-tooltip
                                                v-if="item.STATUS === 'PENDING'"
                                                top
                                            >
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="success"
                                                        v-on="on"
                                                        @click="handleApprovePendingCoverages(item)"
                                                    ><v-icon>{{ mdiCheck }}</v-icon></v-btn>
                                                </template>
                                                <span>Approve</span>
                                            </v-tooltip>
                                            <v-tooltip
                                                v-if="item.SCOPE === 'MEMBER'"
                                                top
                                            >
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-on="on"
                                                        @click="handleShowDiagnostic(item)"
                                                    ><v-icon>{{ mdiEye }}</v-icon></v-btn>
                                                </template>
                                                <span>Show Diagnostic</span>
                                            </v-tooltip>
                                            <v-tooltip top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="primary"
                                                        v-on="on"
                                                        @click="handleShowHistory(item)"
                                                    ><v-icon>{{ mdiFileEye }}</v-icon></v-btn>
                                                </template>
                                                <span>Show History</span>
                                            </v-tooltip>
                                            <v-tooltip v-if="selectedAcu.STATUS === 'IN PROGRESS' || (selectedAcu.STATUS === 'ACTIVE' && item.STATUS === 'PENDING')" top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="warning"
                                                        v-on="on"
                                                        @click="handleEditCoverages(item)"
                                                    ><v-icon>{{ mdiPencil }}</v-icon></v-btn>
                                                </template>
                                                <span>Edit</span>
                                            </v-tooltip>
                                            <v-tooltip v-if="selectedAcu.STATUS === 'IN PROGRESS' || (selectedAcu.STATUS === 'ACTIVE' && item.STATUS === 'PENDING')" top>
                                                <template #activator="{ on }">
                                                    <v-btn
                                                        icon
                                                        color="error"
                                                        v-on="on"
                                                        @click="handleDeleteCoverages(item)"
                                                    ><v-icon>{{ mdiTrashCan }}</v-icon></v-btn>
                                                </template>
                                                <span>Delete</span>
                                            </v-tooltip>
                                        </div>
                                    </template>
                                    <template v-else>
                                        {{ item[header.value] }}
                                    </template>
                                </span>
                            </td>
                        </tr>
                    </template>
                </v-data-table>
            </v-card>
            <NewCoverages
                :show="display.new"
                :data="display.data"
                :existing="viewAccountCoveragesData && Array.isArray(viewAccountCoveragesData.data) ? viewAccountCoveragesData.data : []"
                @closeDialog="display.new = false"
            />
            <UpdateCoverages
                :show="display.update"
                :data="display.data"
                @closeDialog="display.update = false"
            />
            <DeleteCoverages
                :show="display.delete"
                :data="display.data"
                @closeDialog="display.delete = false"
            />
            <ShowHistory
                :show="history.status"
                :data="history.data"
                @closeDialog="history.status = false"
            />
            <ScopedBenefit
                :show="scopedBenefit.status"
                :data="scopedBenefit.data"
                :notif="notif"
                @closeDialog="handleCloseDiagnostic"
            />
        </v-dialog>
    </section>
</template>

<script>
import { moment } from '../../../../../utils/date-shim'
import { mapActions, mapGetters } from 'vuex'
import NewCoverages from './NewCoverages.vue'
import UpdateCoverages from './UpdateCoverages.vue'
import DeleteCoverages from './DeleteCoverages.vue'
import ShowHistory from './ShowHistory.vue'
import ScopedBenefit from './ScopedBenefit/IndexPage.vue'
import {
    mdiCheck,
    mdiPlus,
    mdiClose,
    mdiTimerSand,
    mdiEye,
    mdiFileEye,
    mdiPencil,
    mdiTrashCan
} from '@mdi/js'

export default {
    components: { NewCoverages, UpdateCoverages, DeleteCoverages, ShowHistory, ScopedBenefit },
    props: ['show', 'selectedAcu'],
    data: ()=>({
        mdiCheck,
        mdiPlus,
        mdiClose,
        mdiTimerSand,
        mdiEye,
        mdiFileEye,
        mdiPencil,
        mdiTrashCan,
        hoveredRow: null,
        scopedBenefit: {
            status: false,
            data: null
        },
        notif: {
            show: false,
            type: 'success',
            msg: 'Done',
            color: 'success'
        },
        history: {
            status: false,
            data: null
        },
        display: {
            new: false,
            update: false,
            delete: false,
            data: []
        },
        coverages: [],
        headers: [
            { text: 'Number', value: 'ROW_N', align: 'center' },
            { text: 'Diagnostic', value: 'DIAG_T' },
            { text: 'Scope', value: 'SCOPE', align: 'center' },
            { text: 'Age', value: 'AGE', align: 'center' },
            { text: 'Gender', value: 'SEX', align: 'center' },
            { text: 'Status', value: 'STATUS', align: 'center' },
            { text: 'Added By', value: 'ADDED_BY', align: 'center' },
            { text: 'Added On', value: 'ADDED_ON', align: 'center' },
            { text: 'Approved By', value: 'APPROVED_BY', align: 'center' },
            { text: 'Approved On', value: 'APPROVED_ON', align: 'center' },
            { text: 'Actions', value: 'ACTIONS', align: 'center' }
        ],
        screen_width: document.documentElement.clientWidth + 9
    }),
    computed: {
        ...mapGetters(['viewAccountCoveragesData', 'editAccountCoverageData', 'deleteAccountCoverageData', 'addAccountCoverageData', 'approveAccountCoverageData']),
        showDialog: {
            get() {
                if (this.show) this.initData()
                return this.show
            },
            set() {
                this.$emit('closeDialog')
            }
        },
        showApproveAll() {
            return this.selectedAcu.BENEFITS_STATUS === 'PENDING' && (this.selectedAcu.STATUS === 'PENDING' || this.selectedAcu.STATUS === 'ACTIVE') && this.viewAccountCoveragesData && this.viewAccountCoveragesData.data.some(item => item.STATUS === 'PENDING')
        }
    },
    watch: {
        isCoverageHasPending(newVal, oldVal) {
            if (oldVal === true && newVal === false) {
                this.acuActiveList()
            }
        },
        approveAccountCoverageData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Approved!'
                    this.notif.show = true
                    this.viewAccountCoverages({ ACCT_N: this.selectedAcu.ACCT_N })
                    // this.$emit('refreshAcuList', this.selectedAcu.ACCT_N)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        notif: {
            handler(newVal) {
                if (newVal.show) {
                    if (newVal.timeout !== 0) {
                        setTimeout(() => {
                            this.notif.show = false
                        }, newVal.timeout)
                    }
                }
            },
            deep: true
        },
        addAccountCoverageData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'New coverage has been added.'
                    this.notif.show = true
                    this.display.new = false
                    this.viewAccountCoverages({ ACCT_N: this.selectedAcu.ACCT_N })
                    // this.acuActiveList()
                    // this.$emit('refreshAcuList', this.selectedAcu.ACCT_N)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        deleteAccountCoverageData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Coverage has been deleted.'
                    this.notif.show = true
                    this.display.delete = false
                    this.viewAccountCoverages({ ACCT_N: this.selectedAcu.ACCT_N })
                    // this.acuActiveList()
                    // this.$emit('refreshAcuList', this.selectedAcu.ACCT_N)
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        editAccountCoverageData(newVal) {
            if (newVal) {
                if (newVal.status === 200) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'Coverage has been updated.'
                    this.notif.show = true
                    this.display.update = false
                    this.viewAccountCoverages({ ACCT_N: this.selectedAcu.ACCT_N })
                    // this.acuActiveList()

                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
        },
        viewAccountCoveragesData(newVal) {
            if (newVal && newVal.status == 200) {
                let data = newVal.data
                data.sort((a, b) => a.ROW_N - b.ROW_N)
                this.coverages = data
                this.$emit('refreshAcuList', this.selectedAcu.ACCT_N)
            } else {
                this.coverages = []
            }
        }
    },
    mounted() {
        window.addEventListener('resize', this.onResize)
    },
    destroyed(){
        window.removeEventListener('resize', this.onResize)
    },
    methods: {
        ...mapActions(['viewAccountCoverages', 'approveAccountCoverage', 'acuActiveList']),
        makeAgeStatement(item) {
            if (item.AGE_MN && item.AGE_MN > 0 && item.AGE_MX && item.AGE_MX < 120) {
                return `For ${item.AGE_MN}-${item.AGE_MX} y/o only`
            } else if (item.AGE_MN && item.AGE_MN > 0 && !(item.AGE_MX && item.AGE_MX < 120)) {
                return `For ${item.AGE_MN} y/o and above only`
            } else if (item.AGE_MX && item.AGE_MX < 120 && !(item.AGE_MN && item.AGE_MN > 0)) {
                return `For ${item.AGE_MX} y/o and below only`
            } else {
                return 'All Ages'
            }
        },
        handleCloseDiagnostic() {
            this.$store.commit('FETCH_MEMBERS_OF_SCOPED_BENEFIT', null)
            this.scopedBenefit.status = false
        },
        handleShowDiagnostic(data) {
            this.scopedBenefit.data = data
            this.scopedBenefit.status = true
        },
        handleShowHistory(data) {
            this.history.data = data
            this.history.status = true
        },
        handleApproveAllPendingCoverages() {
            this.coverages.forEach(item => {
                if (item.STATUS === 'PENDING') {
                    this.approveAccountCoverage({ ID: item.ID, ACCT_N: item.ACCT_N })
                }
            })
        },
        handleApprovePendingCoverages(item) {
            this.approveAccountCoverage({ ID: item.ID, ACCT_N: item.ACCT_N })
        },
        handleNewCoverages() {
            let data = {
                ACCT_N: this.selectedAcu.ACCT_N,
                ACCT_M: this.selectedAcu.ACCT_M,
                DIAG_T: null,
                AGE_MN: 0,
                AGE_MX: 120,
                SEX: 'A',
                SCOPE: 'ACCOUNT'
            }
            this.display.data = data
            this.display.new = true
        },
        handleDeleteCoverages(item) {
            let data = {
                ID: item.ID,
                ACCT_N: this.selectedAcu.ACCT_N,
                ACCT_M: this.selectedAcu.ACCT_M,
                DIAG_T: item.DIAG_T,
                AGE_MN: item.AGE_MN,
                AGE_MX: item.AGE_MX,
                SEX: item.SEX,
                SCOPE: item.SCOPE
            }
            this.display.data = data
            this.display.delete = true
        },
        handleEditCoverages(item) {
            let data = {
                ID: item.ID,
                ACCT_N: this.selectedAcu.ACCT_N,
                ACCT_M: this.selectedAcu.ACCT_M,
                DIAG_T: item.DIAG_T,
                AGE_MN: item.AGE_MN,
                AGE_MX: item.AGE_MX,
                SEX: item.SEX,
                SCOPE: item.SCOPE
            }
            this.display.data = data
            this.display.update = true
        },
        formatDate(date) {
            return moment(date).format('MMMM D, YYYY HH:mm:ss')
        },
        initData() {
            // this.viewAccountCoverages({ ACCT_N: this.selectedAcu.ACCT_N })
        },
        onResize() {
            this.screen_width = document.documentElement.clientWidth
            this.screen_width = this.screen_width + 9
        }
    }
}
</script>

<style>
.acuProvisionCoverage > div > table > tbody > tr > td:last-child {
    position: sticky !important;
    right: 0;
    padding: 0;
    z-index: 2; /* Ensure the first column has a higher z-index */
    background: white;
}
.acuProvisionCoverage .sticky-col {
  position: sticky;
  right: 0;
  background: white;
  z-index: 2;
  white-space: nowrap;
}
.acuProvisionCoverage .v-data-table__wrapper {
  overflow-y: auto;
  max-height: 70vh;
}
.acuProvisionCoverage > div > table > thead > tr > th:last-child {
    position: sticky !important;
    right: 0;
    z-index: 5 !important; /* Ensure the first column has a higher z-index */
    background: white;
}
</style>
